import { Page } from '@/core/architecture'

import { ConsoleHomeTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleHome Page
 * Implemented as a practical sample.
 */
export const ConsoleHome: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleHomeTemplate state={state} {...actions} />
}
